// The referral flow's own stepper styles — imported rather than copied, so the two flows
// cannot drift apart visually. Its Steps component hardcodes referral step names, which is
// why the markup is repeated here and the CSS is not.
import style from "../../../PatientReferralsPage/components/AddReferralForm/components/Steps/Steps.module.css";

// One step, because there is one: the practice names the destination and the browser goes
// straight out to Healthlink from there. What used to be step two was an extra screen
// asking the GP to click through, which the redirect removed.
export const LabOrderSteps = () => (
  <ul className={style.stepsWrapper}>
    <li className={`${style.step} ${style.stepActive}`}>
      <div className={`${style.stepNumber} ${style.stepNumberActive}`}>1</div>
      <p className={style.stepName}>Laboratory</p>
    </li>
  </ul>
);
